function parseJson(text) {
    const hijackPreventionPrefix = ")]}',";
    if (text.startsWith(hijackPreventionPrefix)) {
        return JSON.parse(text.slice(hijackPreventionPrefix.length));
    }
    return JSON.parse(text.trim());
}

export { parseJson };
//# sourceMappingURL=parseJson.js.map
